module.exports = __webpack_public_path__ + "img/06.6a3ddab5.png";